// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconOfficeBuilding2 = createRemixIcon('IconOfficeBuilding2', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.25 2.25h9V24H13.5v-4.75h-3V24H1.75V2.25h9V0h2.5zm-9 2.5V21.5H8v-4.75h8v4.75h3.75V4.75zm4.5 2h-3v3h3zm0 4.75h-3v3h3zm4.75 0h-3v3h3zm1.75 0h3v3h-3zM10.5 6.75h3v3h-3zm7.75 0h-3v3h3z\" clip-rule=\"evenodd\"/>");
